import React from 'react';
import './LetsCareersLogo.css';

// Die Unterstreichung als SVG-Pfad – dieselbe im Logo und im Ladescreen.
// Gezeichnet wird per stroke-dashoffset (LetsCareersLogo.css).
export function LogoUnderline({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 210 9"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        className="lc-logo__path"
        d="M2,5 Q28,2 55,6 Q82,9 110,4 Q138,0 162,5 Q183,8 198,3 Q204,1 208,4"
        fill="none"
        stroke="#f97316"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function LetsCareersLogo({ variant = 'light', size = 'md' }) {
  return (
    <span className={`lc-logo lc-logo--${variant} lc-logo--${size}`}>
      <span className="lc-logo__lets">lets</span>
      <span className="lc-logo__careers">
        careers
        <LogoUnderline className="lc-logo__underline" />
      </span>
    </span>
  );
}
